import { Routes } from '@angular/router';
import { AutoLoginPartialRoutesGuard } from 'angular-auth-oidc-client';
import { canActivateUser } from '../common/auth/guards/auth.guard';
import { EmeaMenuComponent } from './menu/emea-menu.component';

export const EMEA_MENU_ROUTE = '/emea/menu';

export const EMEA_ROUTES: Routes = [
    {
        path: '',
        redirectTo: 'menu',
        pathMatch: 'full'
    },
    {
        path: 'request',
        loadChildren: () => import('./request/request.routes').then((m) => m.REQUEST_ROUTES),
        canActivate: [AutoLoginPartialRoutesGuard, canActivateUser]
    },
    {
        path: 'requests',
        loadChildren: () => import('./requests/requests.routes').then((m) => m.REQUESTS_ROUTES),
        canActivate: [AutoLoginPartialRoutesGuard, canActivateUser]
    },
    {
        path: 'tasks',
        loadChildren: () => import('./tasks/tasks.routes').then((m) => m.TASKS_ROUTES),
        canActivate: [AutoLoginPartialRoutesGuard, canActivateUser]
    },
    {
        path: 'menu',
        component: EmeaMenuComponent,
        canActivate: [AutoLoginPartialRoutesGuard, canActivateUser]
    },
    {
        path: 'settings',
        loadChildren: () => import('./settings/settings.routes').then((m) => m.SETTINGS_ROUTES),
        canActivate: [AutoLoginPartialRoutesGuard, canActivateUser]
    }
];
